import { AuthContextFactory } from "./AuthContextFactory";
import { IAuthenticationContext, IUser } from "./Interfaces";
import { Config } from "~/config";
import { authConfig } from "~/ad-authentication";
import { ProductCatalogUIContext } from "~/ProductCatalogUIContext";

const adResourceId = Config.getValue("UI:AD_RESOURCE_ID");
const vstsResourceId = Config.getValue("UI:VSTS_RESOURCE_ID");
const prodcatResourceId = Config.getValue("UI:PRODCAT_RESOURCE_ID");
const graphResourceId = Config.getValue("UI:GRAPH_RESOURCE_ID");
const adoOrgApiResourceId = Config.getValue("UI:ADO_ORG_API_RESOURCE_ID");

let cachedUser: IUser;
let authContext: IAuthenticationContext | undefined;

export const AuthTokenProvider = {
    authenticateUser: async (): Promise<boolean> => {
        try {
            await AuthTokenProvider.acquireAdToken();
            await cacheCurrentUser();

            return Promise.resolve(true);
        } catch (error) {
            return Promise.reject(false);
        }
    },

    isTokenRenewalInProgress: async (): Promise<boolean> => {
        return getAuthContext().isTokenRenewalInProgress();
    },

    handleWindowCallback: async () => {
        await getAuthContext().tryHandleWindowCallBack();
    },

    acquireAdToken: async (): Promise<string> => {
        return getAuthContext().acquireToken(adResourceId);
    },

    acquireVstsToken: async (): Promise<string> => {
        return getAuthContext().acquireToken(vstsResourceId);
    },

    acquireGraphToken: async (): Promise<string> => {
        return getAuthContext().acquireToken(graphResourceId);
    },

    acquireProdcatToken: async (): Promise<string> => {
        return getAuthContext().acquireToken(prodcatResourceId);
    },

    acquireAdoOrgToken: async (): Promise<string> => {
        return getAuthContext().acquireToken(adoOrgApiResourceId);
    },

    getCurrentUser: () => {
        return cachedUser;
    },

    getUserName: () => {
        return cachedUser.userName;
    },

    getUserHomeAccountId: () => {
        return cachedUser.profile.oid;
    },

    queueTokenRequestForUsedResourceIds: () => {
        void AuthTokenProvider.acquireVstsToken();
    }
}

async function cacheCurrentUser() {
    cachedUser = await getAuthContext().getCurrentUser();
}

function getAuthContext(): IAuthenticationContext {
    if (authContext) {
        return authContext;
    }
    const isInsideIFrame = (window.parent !== window) && (!ProductCatalogUIContext.isStandaloneUI);
    authContext = AuthContextFactory.getAuthContext(authConfig.getAadConfig(), isInsideIFrame);

    return authContext;
}